export const UNREAD_SECTION_SLUGS = Object.freeze([
  'help',
  'ideas',
  'showcase',
  'announcements',
  'quarterly-challenge',
]);
export const UNREAD_COUNT_KEYS = Object.freeze([...UNREAD_SECTION_SLUGS, 'messages']);

export function emptyUnreadCounts() {
  return Object.fromEntries(UNREAD_COUNT_KEYS.map((slug) => [slug, 0]));
}

export function normalizeUnreadCounts(response) {
  const source =
    response && response.data && typeof response.data === 'object' && !Array.isArray(response.data)
      ? response.data
      : {};

  return Object.fromEntries(
    UNREAD_COUNT_KEYS.map((slug) => {
      const value = Number(source[slug]);

      return [slug, Number.isInteger(value) && value > 0 ? value : 0];
    })
  );
}

export async function fetchUnreadCounts(app) {
  if (!app.session.user) return emptyUnreadCounts();

  try {
    const response = await app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/yingtao/unread-counts`,
    });

    return normalizeUnreadCounts(response);
  } catch (error) {
    return emptyUnreadCounts();
  }
}

export function formatUnreadCount(value) {
  const count = Number(value);

  if (!Number.isInteger(count) || count <= 0) return '';

  return count > 99 ? '99+' : String(count);
}
